var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBloodPressureMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#B3E2D7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9266 26C11.1002 26 8 22.8375 8 18.9359C8 16.852 8.9002 15 10.3096 13.7066V8.70937C10.3096 6.10762 12.3764 4 14.9266 4C17.4768 4 19.5436 6.10762 19.5436 8.70937V13.7066C20.9508 15 21.8531 16.852 21.8531 18.9359C21.8531 22.8375 18.7529 26 14.9266 26ZM17.9988 15.4555L17.2361 14.7551V8.70937C17.2361 7.41172 16.2006 6.35469 14.9266 6.35469C13.6547 6.35469 12.617 7.41172 12.617 8.70937V14.7551L11.8521 15.4576C10.8574 16.3707 10.3074 17.6082 10.3074 18.9381C10.3074 21.5355 12.3785 23.6475 14.9244 23.6475C17.4703 23.6475 19.5414 21.5355 19.5414 18.9381C19.5436 17.6061 18.9957 16.3707 17.9988 15.4555ZM14.9266 22.9385C12.7631 22.9385 11.0014 21.1424 11.0014 18.9359C11.0014 17.8102 11.4676 16.7596 12.3184 15.9797L13.3109 15.0709V10.9846L16.5422 11.8096V15.0688L17.5348 15.9797C18.3834 16.7617 18.8518 17.8123 18.8518 18.9359C18.8518 21.1424 17.09 22.9385 14.9266 22.9385ZM21.0389 6.44492H21.4471C21.8961 6.44492 22.2613 6.81016 22.2613 7.25918C22.2613 7.7082 21.8961 8.07344 21.4471 8.07344H21.0389C20.5898 8.07344 20.2246 7.7082 20.2246 7.25918C20.2246 6.81016 20.5877 6.44492 21.0389 6.44492ZM21.0389 8.8877H21.4471C21.8961 8.8877 22.2613 9.25293 22.2613 9.70195C22.2613 10.151 21.8961 10.5162 21.4471 10.5162H21.0389C20.5898 10.5162 20.2246 10.151 20.2246 9.70195C20.2225 9.25293 20.5877 8.8877 21.0389 8.8877Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0389 11.3326H21.4471C21.8961 11.3326 22.2613 11.6978 22.2613 12.1469C22.2613 12.5959 21.8961 12.9611 21.4471 12.9611H21.0389C20.5899 12.9611 20.2246 12.5959 20.2246 12.1469C20.2225 11.6978 20.5877 11.3326 21.0389 11.3326Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloodPressureMark);
export default __webpack_public_path__ + "static/media/blood_pressure_mark.727347452c068b98df95112bcdc485a7.svg";
export { ForwardRef as ReactComponent };